import common from './en-US/common';
import charAndTableComponent from './en-US/charAndTableComponent';
import dataManagement from './en-US/dataManagement';
import dataSourceComponent from './en-US/dataSourceComponent';
import extraction from './en-US/extraction';
import multidimensional from './en-US/multidimensional';
import myAnalysis from './en-US/myAnalysis';
import numberPackage from './en-US/numberPackage';
import sortableDragComponent from './en-US/sortableDragComponent';
import uploadFileComponent from './en-US/uploadFileComponent';
import noDataComponent from './en-US/noDataComponent';
import exploration from './en-US/exploration';
import gptChat from './en-US/gptChat';
import createDashboard from './en-US/createDashboard';
import dashboardList from './en-US/dashboardList';
import menu from './en-US/menu';
import sqlAddSource from './en-US/sqlAddSource';
import home from './en-US/home';
import virtualTable from './en-US/virtualTable';
import date from './en-US/date';
import sqlView from './en-US/sqlView';
import modelManagement from './en-US/modelManagement';
import game from './en-US/game';
import error from './en-US/error';
import personalData from './en-US/personalData';
import userFilter from './en-US/userFilter';
import abExperiment from './en-US/abExperiment';
import aiAnalysis from './en-US/aiAnalysis';

export default {
  ...common,
  ...charAndTableComponent,
  ...dataManagement,
  ...dataSourceComponent,
  ...extraction,
  ...multidimensional,
  ...myAnalysis,
  ...numberPackage,
  ...sortableDragComponent,
  ...uploadFileComponent,
  ...noDataComponent,
  ...exploration,
  ...gptChat,
  ...createDashboard,
  ...dashboardList,
  ...menu,
  ...sqlAddSource,
  ...home,
  ...virtualTable,
  ...date,
  ...sqlView,
  ...modelManagement,
  ...game,
  ...error,
  ...personalData,
  ...userFilter,
  ...abExperiment,
  ...aiAnalysis,
};
